export default "__VITE_ASSET__D$YfOBOT__"